import React, { Component } from 'react';
import Item from '../organization/Item';

class CongregationsList extends Component {
  render() {
    let congregations = [];

    this.props.congregations.forEach((unit, index) => {
        congregations.push(<RelatedItem information={unit} key={unit.id} children="" delete={this.props.onHandleDetachCongregation} user={this.props.user} />);
    });

    return (
      <div className="OrganizationsList">
        {congregations}
      </div>
    );
  }
}

const RelatedItem = (props) => {
    if(props.user.type==="admin") {
      return(
        <div style={{position: 'relative', display: 'flex'}}>
          <Item information={props.information} />
          <div style={{display: 'flex', margin: '0 1em', alignItems: 'center'}}>
            <img
                src="/images/assets/kryds.svg"
                alt="Fjern tilknytning"
                height="26"
                width="26"
                style={{cursor: 'pointer'}}
                onClick={() => props.delete(props.information.id)}
              />
          </div>
        </div>
      )
    } else {
      return(
        <div style={{position: 'relative', display: 'flex'}}>
          <Item information={props.information} hideEditLink={true} />
        </div>
      )
    }
}

export default CongregationsList;


// WEBPACK FOOTER //
// ./src/modules/congregations/List.js